module.exports = __webpack_public_path__ + "static/media/logo.977273b5.png";